import { useEffect, useContext, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { mfaLayoutRoutes } from '../../routes/route';

export default function MfaGuard({ children }) {
  const location = useLocation();
  const history = useHistory();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const mfaVerificationRequired = localStorage.getItem('mfa_verification_required') === 'true';
    const noticeMfaVerificationRequired = localStorage.getItem('notice_mfa_verification_required') === 'true';

    const mfaInProgress = mfaVerificationRequired || noticeMfaVerificationRequired;
    const isOnMfaRoute = mfaLayoutRoutes.includes(location.pathname);

    console.log('MFA Guard:', {
      mfaInProgress,
      isOnMfaRoute,
      pathname: location.pathname,
    });

    if (mfaInProgress && !isOnMfaRoute) {
      console.warn('User attempted to leave MFA flow. Redirecting back to MFA.');

      const activateMfaLater = localStorage.getItem('activateMfaLater');
      let fallbackMfaRoute = '';

      if (activateMfaLater || !mfaInProgress) {
        fallbackMfaRoute = '/AccountSummary';
      } else {

        fallbackMfaRoute = noticeMfaVerificationRequired
          ? '/multifactorAuthenticationNotice'
          : mfaVerificationRequired
          ? '/showMultifactorAuthentication'
          : '/';
      }

      history.replace(fallbackMfaRoute);

      return;
    }

    setChecked(true);
  }, [location.pathname, history]);

  if (!checked) return null;

  return children;
}
